import React from 'react';
import { connect } from 'react-redux';
import { chatOff, popupBot } from '../../actions';
import history from '../../history';
import { dataBaseManager } from '../hupUtils/utils';
import { Modal, Col, Row, Container } from 'react-bootstrap';
import Tasks from './tasks';
import Objetives from './objetives';

class DashBoard extends React.Component {

    state = {}


    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }

    componentDidMount() {

        if (!this.props.isSignedIn)
            history.push('/');
        this.props.chatOff();
    }


    renderObjetives(aling) {
        return (
            <Objetives
                titulo={'Tus objetivos de la semana'}
                icono={'thumbtack'}
                alingD={aling}
            />
        );
    }

    renderTasks(aling) {

        return (
            <Tasks
                titulo={'Numero de actividades a finalizar'}
                icono={'thumbtack'}
                alingD={aling}
            />
        );
    }
    renderTeletrabajador() {
        return (

            <Container>
                <Row >
                    <Col md={{ span: 3 }} xs={6} className='centerTasks'>
                        {this.renderTasks()}
                    </Col>
                    <Col md={{ span: 7, offset: 2 }} className= 'okrCenterList' xs={12} >
                        {this.renderObjetives()}
                    </Col>
                </Row>
        
            </Container>

        );
    }
    handleClose = () => {
        this.props.chatOff();
    }

    render() {
        let varriable

        varriable = <div>
            {this.renderTeletrabajador()}
        </div>

        let errorMessage = null;
        if (this.props.userDetail && this.props.userDetail.usuario.estado === 'inactivo') {
            errorMessage = <Modal show={this.handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter" className='purple-text'  >
                        Hola Hupper <i className="material-icons md-18">mood_bad</i>!
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid">
                    <Container>
                        <Row>
                            <Col xs={{ offset: 1 }}>
                                <h5>Hemos terminado el tiempo de prueba, escribenos para continuar y seguir acompañandote en tu trabajo</h5>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        }
        return (
            <div> {varriable}
                {errorMessage}
            </div >
        );

    }
};

const mapStateToProps = (state) => {
    return {
        userDetail: state.mainReducer.userDetail,
        isSignedIn: state.mainReducer.isSignedIn,

    };
};
export default connect(mapStateToProps, { chatOff, popupBot })(DashBoard);

///<ListAdjuntos />